import React, { Component } from "react";
import { FormGroup, FormFeedback, FormText, CardHeader, CardFooter, Label } from "reactstrap";
import { withFormsy, propTypes } from "formsy-react";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./form.css";
import { Spinner } from "../../Shared/Spinner";
import draftToMarkdown from "draftjs-to-markdown";
import { upLoadService } from "./UploadImageService";

const CountCharacters = (props) => {
    return (
        <div style={{ float: "right" }}>
            <small style={{ color: "blue" }}>
                Characters :&ensp;{props.count}/{props.maxCount}
            </small>
            {props.stopTyping && (
                <p>
                    {" "}
                    <small style={{ color: "red" }} className="ml-7">
                        Maximum count reached!{" "}
                    </small>
                </p>
            )}
        </div>
    );
};

const MAX_LENGTH = 1000;
class MealRoasterEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
            upLoadImages: [],
            count: 0,
            formError: null,
            stopTyping: false,
            imagesUrl: null,
            currentKey: null,
            isHandleBeforeInput: true,
            isDraft: false,
            isPasted: false,
        };
    }
    handleKeyPress = (e) => {
        this.setState({ currentKey: e.keyCode });
    };
    onEditorChange = (e) => {
        const rawTxt = e.getCurrentContent().getPlainText("").replace(/\n|\r/g, "");
        const wordCount = !!rawTxt && rawTxt.length;
        const stateUpdate = {
            count: !!rawTxt ? rawTxt.length : 0,
        };

        if (wordCount > MAX_LENGTH) {
            stateUpdate["stopTyping"] = true;
        }
        this.setState(stateUpdate);
    };

    onEditorStateChange = (editorState) => {
        const rawValue = draftToMarkdown(convertToRaw(this.state.editorState.getCurrentContent())).trim();
        let stateUpdate = { editorState };
        if (this.state.editorState.getCurrentContent().getPlainText("").replace(/\n|\r/g, "").length <= MAX_LENGTH) {
            stateUpdate["stopTyping"] = false;
        }

        this.setState(stateUpdate, () => {
            if (this.props.isMultiArry) {
                this.props.storeDataInTextArry(this.props.day, this.props.mealType, draftToHtml(convertToRaw(editorState.getCurrentContent())));
            }

            this.onEditorChange(editorState);
            this.props.setValue(rawValue ? draftToHtml(convertToRaw(editorState.getCurrentContent())) : null);
        });
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.submitSucessful) {
            this.resetForm();
        }

        if (nextProps.isEdit && this.props.postBody !== null) {
            this.editValue(this.props.postBody);
            this.props.stopEdit();
        }
    }

    editValue = (data) => {
        let editDataLength = [];
        const blocksFromHTML = convertFromHTML(data);
        const state = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);

        blocksFromHTML.contentBlocks.forEach((e) => {
            editDataLength.push(e.text);
        });

        this.setState({
            editorState: EditorState.createWithContent(state),
            count: editDataLength.join("").replace(/\n|\r/g, "").length,
            isDraft: true,
            isHandleBeforeInput: true,
        });
    };

    resetForm = () => {
        const editorState = EditorState.push(this.state.editorState, ContentState.createFromText(""));
        this.setState({ editorState });
    };
    //========Uplooad image document===================//

    convertCommentFromJSONToHTML = (text) => {
        return stateToHTML(this.state.editorState.getCurrentContent());
    };

    submitPost = (data) => {
        upLoadService
            .submitImage(data)
            .then((response) => {
                this.setState({ imagesUrl: response.imageUrl });
            })
            .catch((error) => this.setState({ formError: error }));
    };

    readImageFile = (file, callback) => {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();

            reader.readAsDataURL(file);
            reader.onloadend = () => {
                let newRefineData = { base64Image: reader.result.substr(22) };

                upLoadService
                    .submitImage(newRefineData)
                    .then((resp) => {
                        if (resp && resp.imageUrl) {
                            resolve({ data: { link: resp.imageUrl } });
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            };
        });
    };

    //==========Handle Character Count======//
    getLengthOfSelectedText = () => {
        const currentSelection = this.state.editorState.getSelection();
        const isCollapsed = currentSelection.isCollapsed();

        let length = 0;

        if (!isCollapsed) {
            const currentContent = this.state.editorState.getCurrentContent();
            const startKey = currentSelection.getStartKey();
            const endKey = currentSelection.getEndKey();
            const startBlock = currentContent.getBlockForKey(startKey);
            const isStartAndEndBlockAreTheSame = startKey === endKey;
            const startBlockTextLength = startBlock.getLength();
            const startSelectedTextLength = startBlockTextLength - currentSelection.getStartOffset();
            const endSelectedTextLength = currentSelection.getEndOffset();
            const keyAfterEnd = currentContent.getKeyAfter(endKey);

            if (isStartAndEndBlockAreTheSame) {
                length += currentSelection.getEndOffset() - currentSelection.getStartOffset();
            } else {
                let currentKey = startKey;

                while (currentKey && currentKey !== keyAfterEnd) {
                    if (currentKey === startKey) {
                        length += startSelectedTextLength + 1;
                    } else if (currentKey === endKey) {
                        length += endSelectedTextLength;
                    } else {
                        length += currentContent.getBlockForKey(currentKey).getLength() + 1;
                    }

                    currentKey = currentContent.getKeyAfter(currentKey);
                }
            }
        }

        return length;
    };

    handleBeforeInput = (e) => {
        const currentContent = this.state.editorState.getCurrentContent();
        const currentContentLength = currentContent.getPlainText("").replace(/\n|\r/g, "").length;
        const selectedTextLength = this.getLengthOfSelectedText();

        if (currentContentLength - selectedTextLength + 1 > MAX_LENGTH) {
            this.setState({ stopTyping: true });
            return "handled";
        } else {
            this.setState({ stopTyping: false });
        }
    };

    handlePastedText = (pastedText) => {
        const currentContent = this.state.editorState.getCurrentContent();
        const currentContentLength = currentContent.getPlainText("").replace(/\n|\r/g, "").length;
        const selectedTextLength = this.getLengthOfSelectedText();

        if (currentContentLength + pastedText.replace(/\n|\r/g, "").length - selectedTextLength > MAX_LENGTH) {
            this.setState({ stopTyping: true, isPasted: true });

            return "handled";
        } else {
            this.setState({ stopTyping: false });
        }
    };
    render() {
        const { editorState, stopTyping, count, isHandleBeforeInput } = this.state;
        const errorMessage = this.props.getErrorMessage();
        const { validating, className, disabled, showRequired, showError, getValue, showLoader, name, title, isPristine, infoText, hasValue, isRequired, toolbarHidden, isViewOnly, submitting, postInterest, postTitle, stripPastedStyles } = this.props;
        const hasError = !isPristine() && (showError() || (isRequired() && !hasValue()));

        return (
            <div>
                <FormGroup className={className}>
                    <CardHeader style={{ paddingLeft: "0.2rem" }}>
                        {title && (
                            <Label className={isRequired() && "required"} htmlFor={name}>
                                {title}
                            </Label>
                        )}
                        {postInterest && (
                            <div>
                                <span>Interest: {postInterest}</span>
                                <hr />
                                <p className="mb-2">Title: {postTitle}</p>
                            </div>
                        )}
                    </CardHeader>

                    <Editor
                        handleDrop={true}
                        editorState={editorState}
                        ref="Mealeditor"
                        customDecorators={[
                            {
                                strategy: findImageEntities,
                                component: Image,
                            },
                        ]}
                        editorClassName="mealEditor"
                        wrapperClassName="demo-wrapper"
                        handleBeforeInput={isHandleBeforeInput ? this.handleBeforeInput : null}
                        handlePastedText={this.handlePastedText}
                        onEditorStateChange={!isViewOnly ? this.onEditorStateChange : null}
                        toolbarHidden={toolbarHidden}
                        stripPastedStyles={stripPastedStyles}
                        toolbar={{
                            options: ["inline", "image"],
                            inline: { options: ["bold"] },
                            
                            //unordered: { icon: Icons.unordered},
                            //ordered: { icon: Icons.ordered, className: 'demo-option-custom' },
                            image: {
                                //icon: image,
                                className: undefined,
                                component: undefined,
                                popupClassName: undefined,
                                urlEnabled: false,
                                uploadEnabled: true,
                                alignmentEnabled: false,
                                uploadCallback: this.readImageFile,
                                previewImage: true,
                                inputAccept: "image/jpeg,image/jpg,image/png,image/svg",
                                //  alt: { present: false, mandatory: false },
                                defaultSize: {
                                    // height: "auto",
                                    width: "50%",
                                },
                            },
                        }}
                        name={name}
                        id={name}
                        disabled={validating ? true : false || disabled}
                        value={getValue() || ""}
                    >
                        {submitting ? <Spinner size="sm" /> : null}
                    </Editor>

                    <CardFooter style={{ height: "2rem", textAlign: "center" }}> {!isViewOnly && <CountCharacters count={count} stopTyping={stopTyping} maxCount={MAX_LENGTH} />}</CardFooter>
                    {infoText ? <FormText>{infoText}</FormText> : ""}
                    {hasError ? <FormFeedback>{errorMessage}</FormFeedback> : ""}
                    {showRequired() ? <FormFeedback>Required</FormFeedback> : ""}
                    {showLoader ? <Spinner /> : ""}
                </FormGroup>
            </div>
        );
    }
}
MealRoasterEditor.propTypes = {
    ...propTypes,
};

function findImageEntities(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges((character) => {
        const entityKey = character.getEntity();
        return entityKey !== null && contentState.getEntity(entityKey).getType() === "IMAGE";
    }, callback);
}

const Image = (props) => {
    const { src } = props.contentState.getEntity(props.entityKey).getData();

    return (
        <div className="draft-img">
            <img src={src} width="20%" alt="" style={{ position: "relative", textAlign: "center" }} />
        </div>
    );
};

export default withFormsy(MealRoasterEditor);
